import OrderModal from "@/models/Order";

const CLEAR_ORDER_REFUND = 'CLEAR_ORDER_REFUND';
const GET_ORDER_REFUND_DETAIL = 'GET_ORDER_REFUND_DETAIL';
const REFUND_ORDER = 'REFUND_ORDER';

/**
 * 清除退款申请信息
 */
async function clearOrderRefund() {
  return {
    type: CLEAR_ORDER_REFUND
  }
}

/**
 * 获取退单详情
 * @param {Object} params {
 *    @param {string} tradeCode 订单编号(查订单详情时传入)
 * }
 */
async function getOrderRefundDetail(params) {
  const payload = await new OrderModal().orderDetail(params);
  return {
    type: GET_ORDER_REFUND_DETAIL,
    payload
  }
}

/**
 * 申请退款
 * @param {string} tradeCode 订单编号
 * @param {string} returnReason 退款原因
 */
async function refundOrder({ tradeCode, returnReason }) {
  const payload = await new OrderModal().refundOrder({ tradeCode, returnReason });
  return {
    type: REFUND_ORDER,
    payload
  }
}

const ACTION_TYPES = {
  CLEAR_ORDER_REFUND,
  GET_ORDER_REFUND_DETAIL,
  REFUND_ORDER,
};

const ACTION = {
  clearOrderRefund,
  getOrderRefundDetail,
  refundOrder,
};

const OrderRefund = {
  ACTION_TYPES,
  ACTION
}

export default OrderRefund;